import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hero-with-one-image',
  templateUrl: './hero-with-one-image.component.html',
  styleUrls: ['./hero-with-one-image.component.css'],
})
export class HeroWithOneImageComponent {
  @Input() data!: any;
}
